import axios from '../../constants/axios';
import * as types from '../../constants/actionTypes';

export function loadProductFeaturesSuccess(payload) {
   return { type: types.LOAD_PRODUCT_FEATURES_SUCCESS, payload: payload };
}

export function addProductFeature(payload) {
   return { type: types.ADD_PRODUCT_FEATURE, payload: payload };
}

export function removeProductFeature(payload) {
   return { type: types.REMOVE_PRODUCT_FEATURE, payload: payload };
}


export function loadProductFeaturesById(productId) {
   return function (dispatch) {
      return axios
         .get(`items/productMain/getFeaturesById/${productId}`)
         .then(function (res) {
            dispatch(loadProductFeaturesSuccess({
               productFeatures: res.data
            }));
         });
   };
}



/** WEBPACK FOOTER **
 ** ./src/actions/productMainEdit/productFeatureActions.js
 **/